import { cgw } from '../lib'
import { getConsumerGatewayBasicAuth } from './headers'

export enum GrantType {
  AUTHORIZATION_CODE = 'authorization_code',
}

export enum AuthenticationMethod {
  ORDER_CHECK = 'order-check',
}

export interface AuthenticatePayload {
  grant_type: GrantType
  authentication_method: AuthenticationMethod
  code: string
  hint: string
}

export async function authenticate(id: string, code: string) {
  const payload: AuthenticatePayload = {
    grant_type: GrantType.AUTHORIZATION_CODE,
    code: code,
    authentication_method: AuthenticationMethod.ORDER_CHECK,
    hint: id,
  }

  return cgw.request({
    method: 'POST',
    url: '/oauth/token',
    auth: getConsumerGatewayBasicAuth(),
    data: payload,
  })
}
